import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadSchluesselAusgabeListStatus: 'idle',
    loadSchluesselAusgabeListError: undefined as any,
    loadSchluesselAusgabeListLastArgs: undefined as any,
    loadSchluesselAusgabeStatus: 'idle',
    loadSchluesselAusgabeError: undefined as any,
    saveSchluesselAusgabeStatus: 'idle',
    saveSchluesselAusgabeError: undefined as any,
    deleteSchluesselAusgabeStatus: 'idle',
    deleteSchluesselAusgabeError: undefined as any,

    schluesselAusgabeList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadSchluesselAusgabeList = createAsyncThunk('toSchluesselAusgabeSlice/loadSchluesselAusgabeList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toSchluesselAusgabeSlice.loadSchluesselAusgabeListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/schluesselausgabe/`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadSchluesselAusgabeListStatus } = getState().toSchluesselAusgabeSlice
        return loadSchluesselAusgabeListStatus !== 'pending'
    }
})

export const loadSchluesselAusgabe = createAsyncThunk('toSchluesselAusgabeSlice/loadSchluesselAusgabe', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/schluesselausgabe/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadSchluesselAusgabeStatus } = getState().toSchluesselAusgabeSlice
        return loadSchluesselAusgabeStatus !== 'pending'
    }
})

export const saveSchluesselAusgabe = createAsyncThunk('toSchluesselAusgabeSlice/saveSchluesselAusgabe', async ({ schluesselAusgabe }: any, { rejectWithValue }: any) => {
    let promises = []
    if (schluesselAusgabe?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/schluesselausgabe/${ schluesselAusgabe?.HDR_ID }/`,
            prepareData(schluesselAusgabe),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/schluesselausgabe/`,
            prepareData(schluesselAusgabe),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveSchluesselAusgabeStatus } = getState().toSchluesselAusgabeSlice
        return saveSchluesselAusgabeStatus !== 'pending'
    }
})

export const deleteSchluesselAusgabe = createAsyncThunk('toSchluesselAusgabeSlice/deleteSchluesselAusgabe', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/schluesselausgabe/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteSchluesselAusgabeStatus } = getState().toSchluesselAusgabeSlice
        return deleteSchluesselAusgabeStatus !== 'pending'
    }
})

const SchluesselAusgabeSlice = createSlice({
    name: 'toSchluesselAusgabeSlice',
    initialState,
    reducers: {
        resetloadSchluesselAusgabeListError: (state) => {
            state.loadSchluesselAusgabeListError = undefined
        },
        resetloadSchluesselAusgabe: (state) => {
            state.formItem = undefined
            state.loadSchluesselAusgabeError = undefined
        },
        resetloadSchluesselAusgabeError: (state) => {
            state.loadSchluesselAusgabeError = undefined
        },
        resetsaveSchluesselAusgabe: (state) => {
            state.formItem = undefined
            state.saveSchluesselAusgabeError = undefined
        },
        resetsaveSchluesselAusgabeError: (state) => {
            state.saveSchluesselAusgabeError = undefined
        },
        resetdeleteSchluesselAusgabeError: (state) => {
            state.deleteSchluesselAusgabeError = undefined
        },
        removeFromSchluesselAusgabeListById: (state, action) => {
            state.schluesselAusgabeList = state.schluesselAusgabeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromSchluesselAusgabeListByIds: (state, action) => {
            state.schluesselAusgabeList = state.schluesselAusgabeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.schluesselAusgabeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadSchluesselAusgabeListStatus = 'preloaded'
            state.loadSchluesselAusgabeListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.schluesselAusgabeList = []
            state.loadSchluesselAusgabeListStatus = 'idle'
            state.loadSchluesselAusgabeListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadSchluesselAusgabeList.pending, (state) => {
            state.loadSchluesselAusgabeListStatus = 'pending'
            state.loadSchluesselAusgabeListError = undefined
        })
        builder.addCase(loadSchluesselAusgabeList.fulfilled, (state, action) => {
            state.loadSchluesselAusgabeListStatus = 'idle'

            if (!action.payload) { return }

            state.loadSchluesselAusgabeListLastArgs = action.payload.args

            {
                state.schluesselAusgabeList = action.payload.data

            }
        })
        builder.addCase(loadSchluesselAusgabeList.rejected, (state, action) => {
            state.loadSchluesselAusgabeListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadSchluesselAusgabeListError = action.error.message
            } else {
                state.loadSchluesselAusgabeListError = action.payload
            }
        })

        builder.addCase(loadSchluesselAusgabe.pending, (state) => {
            state.loadSchluesselAusgabeStatus = 'pending'
            state.loadSchluesselAusgabeError = undefined
        })
        builder.addCase(loadSchluesselAusgabe.fulfilled, (state, action) => {
            state.loadSchluesselAusgabeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.schluesselAusgabeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.schluesselAusgabeList.push(newItem) }
                else { state.schluesselAusgabeList[i] = { ...state.schluesselAusgabeList[i], ...newItem } }
            }
        })
        builder.addCase(loadSchluesselAusgabe.rejected, (state, action) => {
            state.loadSchluesselAusgabeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadSchluesselAusgabeError = action.error.message
            } else {
                state.loadSchluesselAusgabeError = action.payload
            }
        })

        builder.addCase(saveSchluesselAusgabe.pending, (state) => {
            state.saveSchluesselAusgabeStatus = 'pending'
            state.saveSchluesselAusgabeError = undefined
        })
        builder.addCase(saveSchluesselAusgabe.fulfilled, (state, action) => {
            state.saveSchluesselAusgabeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.schluesselAusgabeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.schluesselAusgabeList.push(newItem) }
                else { state.schluesselAusgabeList[i] = { ...state.schluesselAusgabeList[i], ...newItem } }
            }
        })
        builder.addCase(saveSchluesselAusgabe.rejected, (state, action) => {
            state.saveSchluesselAusgabeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveSchluesselAusgabeError = action.error.message
            } else {
                state.saveSchluesselAusgabeError = action.payload
            }
        })

        builder.addCase(deleteSchluesselAusgabe.pending, (state) => {
            state.deleteSchluesselAusgabeStatus = 'pending'
            state.deleteSchluesselAusgabeError = undefined
        })
        builder.addCase(deleteSchluesselAusgabe.fulfilled, (state, action) => {
            state.deleteSchluesselAusgabeStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.schluesselAusgabeList = state.schluesselAusgabeList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.schluesselAusgabeList = state.schluesselAusgabeList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteSchluesselAusgabe.rejected, (state, action) => {
            state.deleteSchluesselAusgabeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteSchluesselAusgabeError = action.error.message
            } else {
                state.deleteSchluesselAusgabeError = action.payload
            }
        })

    }
})

export const {
    resetloadSchluesselAusgabeListError,
    resetloadSchluesselAusgabe,
    resetloadSchluesselAusgabeError,
    resetsaveSchluesselAusgabe,
    resetsaveSchluesselAusgabeError,
    resetdeleteSchluesselAusgabeError,
    removeFromSchluesselAusgabeListById,
    removeFromSchluesselAusgabeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = SchluesselAusgabeSlice.actions
export default SchluesselAusgabeSlice.reducer
